var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.14285 16.9667C2.14285 13.8766 4.72448 11.3716 9.99999 11.3716C15.2755 11.3716 17.8571 13.8766 17.8571 16.9667C17.8571 17.4583 17.4985 17.8569 17.056 17.8569H2.94397C2.50153 17.8569 2.14285 17.4583 2.14285 16.9667Z",
    fill: "#9AA1AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9464 5.08901C12.9464 6.71627 11.6273 8.03543 9.99999 8.03543C8.37273 8.03543 7.05357 6.71627 7.05357 5.08901C7.05357 3.46174 8.37273 2.14258 9.99999 2.14258C11.6273 2.14258 12.9464 3.46174 12.9464 5.08901Z",
    fill: "#9AA1AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/icon-profile.12c53011b922fc889ce6d9de63e66a5b.svg";
export { ForwardRef as ReactComponent };